import pushClevertapEvent from '../pushClevertapEvent';

export const completeAdvancedFulfillment = (email: string) => {
  pushClevertapEvent('Complete Adv Fulfillment', {
    Time: new Date().toISOString(),
    Email: email,
  });
};

export const advancedTransferRequest = (email: string) => {
  pushClevertapEvent('Adv Transfer Request', {
    Time: new Date().toISOString(),
    Email: email,
  });
};

export const advancedTransferApprove = (email: string) => {
  pushClevertapEvent('Adv Transfer Approve', {
    Time: new Date().toISOString(),
    Email: email,
  });
};

export const advancedTransferShipment = (email: string) => {
  pushClevertapEvent('Adv Transfer Shipment', {
    Time: new Date().toISOString(),
    Email: email,
  });
};

export const advancedTransferFulfill = (email: string) => {
  pushClevertapEvent('Adv Transfer Fulfill', {
    Time: new Date().toISOString(),
    Email: email,
  });
};
